<template>
	<!-- 预约提货-->
	<div class="page-container">
		<el-form :model="wmOrderForm" ref="ruleFormRef" :rules="rulesForm" class="form-panel" label-position="top"
			:validateOnRuleChange="false">
			<el-col :span="24">
				<div>
<!-- 					<el-row class="title-panel">
						<el-col>
							<span class="title-text">查询条件</span>
						</el-col>
					</el-row> -->
					<el-row class="content-panel border-radius" >
						<!-- 查询-start -->
					<el-row class="query-module">
						<el-row :gutter="5">
							<el-col :span="2" style="margin-top:10px;padding-left:15px">
								查询条件
							</el-col>
							<el-col :span="10">
								<el-form-item>
									<el-input size="small" placeholder="分拨提单号/分单订单号/HBL No."
										v-model="formData.deployPort">
									</el-input>
								</el-form-item>
							</el-col>
								<el-col :span="4">
								<el-form-item>
									<el-input size="small" placeholder="请输入验证码"
										v-model="formData.verificationCode">
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8" style="margin-top: 2px">
								<el-row>
									<el-button type="primary" class="el-button-search" size="small" plain @click="queryGoods">查询</el-button>
									<el-button type="primary" size="small" plain @click="resetForm">重置</el-button>

								</el-row>
							</el-col>
						</el-row>
					</el-row>
					</el-row>
				</div>
				<!-- 查询-end -->

				<!-- 查验预约-start -->

				<el-row class="panel-top">

					<el-col>
						<el-row class="title-panel-external">
							<div class="title-panel">
							<el-col>
							<span class="title-text">查验预约</span>
							</el-col>
							</div>
						</el-row>
						<el-row class="content-panel">
							<el-col>
								<el-row :gutter="10">
									<el-col :span="24" class="blue-bg border-radius">
										<!-- 基本信息-查验-start -->
										<el-row >
										<el-row class="title-panel-external blue-bg">
											<div class="title-panel">
											<el-col>
											<span class="title-text">基本信息</span>
											</el-col>
											</div>
										</el-row>
												<el-row :gutter="15" class="content-panel blue-bg" style="margin:0">
													<el-col :span="4">
														<el-form-item label="分拨提单号:">
															<el-input size="mini" v-model="wmOrderForm.mblNo" readonly>
															</el-input>
														</el-form-item>
													</el-col>
													<el-col :span="4">
														<el-form-item label="分单订单号:">
															<el-input size="mini" v-model="wmOrderForm.orderNo"
																readonly>
															</el-input>
														</el-form-item>
													</el-col>


													<el-col :span="4">
														<el-row>
															<el-form-item label="HBL No.">
																<el-input size="mini" v-model="wmOrderForm.hblNo"
																	readonly>
																</el-input>
															</el-form-item>
														</el-row>
													</el-col>
													<el-col :span="2">
														<el-form-item label="是否危品:">
															<el-input size="mini" v-model="wmOrderForm.isHazardCn"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="2">
														<el-form-item label="库房:">
															<el-input size="mini" v-model="wmOrderForm.areaName"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="2">
														<el-form-item label="件数:">
															<el-input size="mini" v-model="wmOrderForm.noOfPackage"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="2">
														<el-form-item label="重量:">
															<el-input size="mini" v-model="wmOrderForm.grossWeight"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="2">
														<el-form-item label="体积:">
															<el-input size="mini" v-model="wmOrderForm.cube" readonly>
															</el-input>
														</el-form-item>
													</el-col>
													<el-col :span="2">
														<el-form-item label="包装类别:">
															<el-input size="mini" v-model="wmOrderForm.packageType"
																readonly>
															</el-input>
														</el-form-item>
													</el-col>
													<el-col :span="4">
														<el-form-item label="放行信息:">
															<el-input size="mini" v-model="wmOrderForm.releaseStatusCn"
																readonly>
															</el-input>
														</el-form-item>
													</el-col>
													<el-col :span="4">
														<el-form-item label="放行日期:">
															<el-date-picker v-model="wmOrderForm.releaseTime"
																align="right" readonly type="date" style="width:100%;"
																size="mini" placeholder=""
																:picker-options="pickerOptions">
															</el-date-picker>
														</el-form-item>
													</el-col>
													<el-col>
														<hr style="border:1px solid #F0F0F0"></hr>
													</el-col>
													<el-col>
														提货须知：
													</el-col>
													<el-col :span="8" style="margin-top:5px">
													<el-input v-model="wmOrderForm.notice" size="mini" :rows="5" type="textarea" readonly>
													</el-input>
													</el-col>
												</el-row>
											<!-- 基本信息-查验-end -->
										</el-row>
									</el-col>
									<!-- 查验预约-end -->
								<!-- 	<el-col style="height:15px;"></el-col> -->
									<!-- 提货预约信息-begin -->
									<el-col :span="24" style="margin-top:10px;padding:0px" >
										
                                         <el-row class="enlarged-title-panel blue-bg enlarged-title-panel-cargo top-radius  handsontable-set">
												<el-row class="enlarged-title">
													<div class="enlarged-title-text cargo-info-title">
															<span class="title-text">提货预约信息</span>
													</div>
													<div class="enlarged-title-buttons enlarged-title-buttons-cargo">
										    	     <el-button type="primary" size="mini" @click="chargeCalculation">提货费用计算</el-button>
												<!-- begin -->
                                                   </div>
												 </el-row>
										</el-row>
										 <el-row class="content-panel blue-bg" span="12" style="margin:0">
												<el-col :span="24">
													<el-row :gutter="10">
														<el-col :span="6">
															<el-form-item label="提货日期:" :inline="true"
																prop="wmAppApmtListDto.apmtDatePeroid">
																<el-select class="length_input" size="mini"
																	v-model="wmOrderForm.wmAppApmtListDto.apmtDatePeroid"
																	placeholder="请选择">
																	<el-option v-for="item in appointmentDataList"
																		:key="item" :value="item.key"
																		:label="item.value">
																	</el-option>
																</el-select>
															</el-form-item>
														</el-col>
														<el-col :span="6">
															<el-form-item label="预计提货费用:">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.charges"
																	readonly>
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="提货人:" prop="wmAppApmtListDto.driver">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.driver">
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="手机号:" prop="wmAppApmtListDto.driverTel">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.driverTel">
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="车牌号:">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.vehicleCode">
																</el-input>
															</el-form-item>
														</el-col>

													</el-row>
												</el-col>
							        	 </el-row>
								  </el-col>
											<!-- 提货预约信息-end -->
										<!-- 	<el-col style="height:52.09px;"></el-col> -->
								</el-row>
							</el-col>
						</el-row>
					</el-col>
			 </el-row>
		  </el-col>
			<!-- 箱信息-end -->
			<div style="text-align: right">
				<el-button type="primary" size="mini" @click="submitGoods"  class="el-button-search">提交</el-button>
				<el-button type="primary" size="mini" @click="closeTab">关闭</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	import {
		queryWmOrderGoods,
		calculationOfCharges,
		submitPickUpGoods,
	} from "@/api/appointment"
	import {
		bookingFormRules
	} from '@/rules/booking_rules'

	import {
		queryDictRows
	} from "@/api/commonService"

	import {
		ebCtnValidate
	} from '@/rules/ebCtnRules'
	import {
		saveEbCtnAdDradt
	} from "@/api/vgmManage"
	export default {
		name: 'bookingAdd',
		components: {
		},
		data() {
			return {
				accopyStsList: [],
				yesOrNoList: [],
				releaseStatusList: [],
				boxVisible: true,
				moreInfoVisible: false,
				ebOrderForm: {
					mblNo: '',
					carrierName: '',
					vesselNameEn: '',
					voyage: '',
					polName: '',
					vgmVerifyDate: '',

				},
				//提货日期
				appointmentDataList: [],
				//日期设置
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
				searchData: {
					startTime: '',
				},
				readonly: true,
				wmOrderForm: {
					mblNo: null,
					orderNo: null,
					hblNo: null,
					isHazard: null,
					isHazardCn: null,
					areaName: null,
					noOfPackage: null,
					grossWeight: null,
					cube: null,
					packageType: null,
					releaseStatus: null,
					releaseStatusCn: null,
					releaseTime: null,
					apmtDatePeroid: null,
					pickUpFee: null,
					driver: null,
					driverTel: null,
					contactUser: null,
					vehicleCode: null,
					wmOrderId: null,
					notice: '',
					wmAppApmtListDto: {
						wmAppApmtListId: '',
						apmtDatePeroid: '',
						driver: '',
						driverTel: '',
						vehicleCode: '',
						charges: '',
						wmOrderId: ''
					}
				},
				rulesForm: {
					'wmAppApmtListDto.apmtDatePeroid': [{
						required: true,
						message: "提货日期不能为空",
						trigger: ['blur', 'change']
					}],
					'wmAppApmtListDto.driver': [{
						required: true,
						message: "提货人不能为空",
						trigger: ['blur', 'change']
					}],
					'wmAppApmtListDto.driverTel': [{
						required: true,
						message: "提货人手机号不能为空",
						trigger: ['blur', 'change']
					}],

				},
				manifestAddForm: {},
				bookingForm: {
					bookingNum: '',
					customerbusiness_num: '',
					bill_lading_num: '',
					payType: '',
					payer: '',
					pay_place: '',
					clause: '',
					sc: '',
					na: '',
					signing_method: '',
					signing_place: '',
					copies_chief: '',
					copies_deputy: '',
					contacts: '',
					contact_number: '',
					email: '',
					checkList: [],
					etd: '',
					customerNotes: '',
					feedbackNotes: '',
				},
				ebOrderInfoAndEbCtnInfo: {
					ebCtn: [],
					ebOrderId: ""
				},
				// 表格校验
				ebCtnRules: {},
				//搜索框
				formData: {
					deployPort: '',
					verificationCode: null
				},

				//tab状态栏
				activeName: 0,
				// 表格数据
				ebCtnTableDataSource: [],
				// 表格设置
				ebCtnTableSettings: {
					height: 205,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					afterChange: this.afterChangeMe,
					...this.$systemConfig.tableConfig
				},

				cargoInfoForm: {
					checkList: [],
					shippingMark: '父向子传值', //唛头
					cargoDetail: '', //货物描述
					pieces: '',
					package: '',
					grossWeight: '', //毛重
					volume: '', //体积
					netWeight: '', //净重
					hsCode: '',
					cargoInfoArr: [0]
				},
			};
		},
    async created() {

			let self = this;
			if (!self.wmOrderForm.releaseStatus) {
				//隐藏第5点须知内容
				self.isAbleOne = false
			}
		},
		mounted() {
			let _this = this
			_this.getSelectList()
			//接收订舱管理界面-VGM维护
			if (_this.$route.params.ebOrder !== undefined) {
				let ebOrder = _this.$route.params.ebOrder
				_this.ebOrderForm = ebOrder
				console.log("_this.$route.params.ebOrder:", ebOrder)
			}

			_this.ebCtnRules = ebCtnValidate()
			_this.resizeObserver = new ResizeObserver(entries => {
				_this.$nextTick(() => {
					if (this.boxVisible) {
						_this.$refs.boxInfoTableRef.resizeTo(entries[0].target.clientWidth - 19)
					} else {
						_this.$refs.boxDetailTableRef.resizeTo(entries[0].target.clientWidth - 19)
					}
				})
			});
			_this.resizeObserver.observe(document.getElementById("boxDiv"));
		},
		methods: {
			resetForm(){
				this.formData = {}
			},
			  closeTab() {
        this.$store.state.tagsView.visitedViews.splice(
          this.$store.state.tagsView.visitedViews.findIndex(
            (item) => item.path === this.$route.path
          ),
          1
        );
        this.$router.push(
          this.$store.state.tagsView.visitedViews[
            this.$store.state.tagsView.visitedViews.length - 1
          ].path
        );
      },
			//查询
			queryGoods() {
				let self = this
				// if((self.formData.deployPort === null || self.formData.deployPort === '') || self.formData.verificationCode === null)  return self.$coreMethods.message("warning", "请输入订单单号或验证码");
					if((self.formData.deployPort === null || self.formData.deployPort === ''))  return self.$coreMethods.message("warning", "请输入订单单号");
				queryWmOrderGoods({
					orderNoParam: self.formData.deployPort,
					verificationCode: self.formData.verificationCode
				}).then(res => {
					if (res.success) {
						if( res.wmOrderAppointment === null) return self.$coreMethods.message("error", "订单数据不存在，请确认");
						self.wmOrderForm.cube = res.wmOrderAppointment.cube
						self.wmOrderForm.grossWeight = res.wmOrderAppointment.grossWeight
						self.wmOrderForm.isHazard = res.wmOrderAppointment.isHazard
						self.yesOrNoList.forEach(item => {
							if(res.wmOrderAppointment.isHazard === item.key) {
								self.wmOrderForm.isHazardCn = item.value
							}
						})
						self.wmOrderForm.noOfPackage = res.wmOrderAppointment.noOfPackage
						self.wmOrderForm.orderNo = res.wmOrderAppointment.orderNo
						self.wmOrderForm.areaName = res.wmOrderAppointment.areaName
						self.wmOrderForm.packageType = res.wmOrderAppointment.packageType
						self.wmOrderForm.releaseStatus = res.wmOrderAppointment.releaseStatus;
						self.releaseStatusList.forEach(item => {
							if(res.wmOrderAppointment.releaseStatus === item.key) {
								self.wmOrderForm.releaseStatusCn = item.value
							}
						})
						self.wmOrderForm.releaseTime = res.wmOrderAppointment.releaseTime
						self.wmOrderForm.wmOrderId = res.wmOrderAppointment.wmOrderId
						self.wmOrderForm.mblNo = res.wmOrderAppointment.mblNo
						self.wmOrderForm.hblNo = res.wmOrderAppointment.hblNo
						self.wmOrderForm.notice = []
						res.wmOrderAppointment.noticeList.forEach(item => {
							self.wmOrderForm.notice = self.wmOrderForm.notice + item
						});
						if (res.wmOrderAppointment.wmAppApmtListDto != null) {
							res.wmOrderAppointment.wmAppApmtListDto.charges = null;
							self.wmOrderForm.wmAppApmtListDto = res.wmOrderAppointment.wmAppApmtListDto
							delete self.wmOrderForm.wmAppApmtListDto.apmtDate
						}else {
							self.wmOrderForm.wmAppApmtListDto = {charges: null,wmOrderId: res.wmOrderAppointment.wmOrderId }
						}
						//获取下拉框数据appointmentDataList

						let params = res.wmOrderAppointment.apmtDateVoList

						params.forEach(item => {
							let param = {}
							param.value = item.value
							param.key = item.key
							self.appointmentDataList.push(param)
						});
						self.$forceUpdate();
					}
				}).catch((error) => {
					 const errorObj = JSON.parse(
                error.response.data.header.errorMessage.split("返回内容：")[1]
              );
              this.$coreMethods.message("error", errorObj.errorMessages[0]);
				})
			},
			//提货费用计算
			chargeCalculation() {
				let self = this
				if (!self.wmOrderForm.wmAppApmtListDto.apmtDatePeroid) {
					self.$coreMethods.message('warning', '请输入提货日期！')
				} else {
					let params = {}
					params.apmtDate = self.wmOrderForm.wmAppApmtListDto.apmtDatePeroid
					params.wmOrderId = self.wmOrderForm.wmAppApmtListDto.wmOrderId
					calculationOfCharges(params).then(res => {
						if (res.success) {
							self.wmOrderForm.wmAppApmtListDto.charges = res.charges
							self.$coreMethods.message('success', '运费计算成功!')
						}
					})
				}
			},
			deleteKey(data) {
				for (const key in data) {
					if (!data[key]) {
						delete data[key]
					}
				}
			},
			//提交
			submitGoods() {
				let self = this
				self.$refs.ruleFormRef.validate(valid => {
					if (valid) {
						// self.wmOrderForm.wmAppApmtListDto.wmOrderId = self.wmOrderForm.wmOrderId
						submitPickUpGoods({
							wmAppApmtListDto: this.wmOrderForm.wmAppApmtListDto
						}).then(res => {
							if (res.success) {
								self.$coreMethods.message('success', '提交成功！')
								self.queryGoods();
							} else {
								self.$coreMethods.message('error', '提交失败！')
							}
						})
					}
				})
			},

			//获取数据字典
			getSelectList() {
				let self = this
				queryDictRows('MD_CODE_DICT$ACCOPY_STS,MD_CODE_DICT$RELEASE_STATUS,MD_CODE_DICT$MD_CODE_YESNO').then(res => {
					/*name:value value:key*/
					console.log("queryDictRows:", res)
					//付款方式
					self.accopyStsList = res.MD_CODE_DICT$ACCOPY_STS;
					self.yesOrNoList = res.MD_CODE_DICT$MD_CODE_YESNO;
					self.releaseStatusList = res.MD_CODE_DICT$RELEASE_STATUS;

				})
			},

			boxInfoFn() {
				this.boxVisible = true;
				let containerWidth = document.getElementById('boxDiv').clientWidth - 21.22;
				this.$nextTick(() => {
					this.$refs.boxInfoTableRef.resizeTo(containerWidth)
				})
			},

			boxDetailFn() {
				this.boxVisible = false;
				let containerWidth = document.getElementById('boxDiv').clientWidth - 21.22;
				this.$nextTick(() => {
					this.$refs.boxDetailTableRef.resizeTo(containerWidth)
				})
			}
		},
		beforeDestroy() {
			let _this = this
			// 离开页面删除检测器和所有侦听器
			_this.resizeObserver.disconnect();
		},
	};
</script>

<style scoped lang="less">

</style>
